import { SaleEvent } from '@support/models/sale-event';
import { CreateCompetition, UpdateCompetition } from '@support/models/create-competition.model';

export class AddCompetitionAction {
  public static readonly type = '[Competition] Add competition';
}

export class CancelCompetitionAction {
  public static readonly type = '[Competition] Cancel competition';
}

export class CreateCompetitionAction {
  public static readonly type = '[Competition API] Create competition';
  constructor(public createCompetition: CreateCompetition) {}
}

export class UpdateCompetitionAction {
  public static readonly type = '[Competition API] Update competition';
  constructor(public updateCompetition: UpdateCompetition) {}
}

export class DeleteCompetitionAction {
  public static readonly type = '[Competition API] Delete competition';
  constructor(public id: string) {}
}

export class GetDealerCompetitionsAction {
  public static readonly type = '[Competition API] Get dealer competitions';

  // A background resync must not raise the loading flag, because the list page replaces
  // the card list with a spinner and would flicker on every sale event
  constructor(public isBackgroundRefresh = false) {}
}

export class SetDealerImpersonationAction {
  public static readonly type = '[Competition] Set dealer impersonation';

  constructor(public dealerId: string | null) {}
}

export class CompetitionResetAction {
  public static readonly type = '[Competition] Reset competition state';
}

export class UpdateCompetitionFromEventAction {
  public static readonly type = '[Competition API] Update competition from event';
  constructor(public saleEvent: SaleEvent) {}
}
